<div *ngIf="documents$ | async as documents">
  <div *ngFor="let document of documents.content" class="ui-g">
    <div class="ui-g-12">
      <div [ngSwitch]="document.state" class="inline-block m-r-5">
        <div *ngSwitchCase="true">
          <i class="fa fa-check primary-color"></i>
        </div>
        <div *ngSwitchCase="false">
          <i class="fa fa-times text-danger"></i>
        </div>
        <div *ngSwitchDefault style="opacity: .5">
          <i class="fas fa-question"></i>
        </div>
      </div>&nbsp;{{ document.documentName }}
    </div>
  </div>
</div>
